import { Location } from 'react-router-dom';
import { SupportedOrgs } from '../config/storeConfig';

const COLLECTION_PATH_PATTERN = /^\/collection\/([^/]+)\/?$/;

export function parseCollectionHandleFromReferrer(
  referrer: string = document.referrer
): string | undefined {
  if (!referrer) {
    return undefined;
  }

  try {
    const url = new URL(referrer);
    if (url.origin !== window.location.origin) {
      return undefined;
    }
    const match = url.pathname.match(COLLECTION_PATH_PATTERN);
    return match?.[1];
  } catch {
    return undefined;
  }
}

/**
 * Collection URL for the header back control: referrer PLP first, then org context.
 */
export function resolveCollectionBackPath(params: {
  orgId?: SupportedOrgs;
  collectionHandle?: string;
}): string | undefined {
  const { orgId, collectionHandle } = params;
  if (!orgId) {
    return undefined;
  }

  const referrerHandle = parseCollectionHandleFromReferrer();
  if (referrerHandle) {
    return `/collection/${referrerHandle}`;
  }

  return collectionHandle ? `/collection/${collectionHandle}` : undefined;
}

/** Prefer router state from PLP navigation; fall back to default collection path. */
export function resolveBackPath(
  location: Location,
  params: { orgId?: SupportedOrgs; collectionHandle?: string }
): string | undefined {
  const from = (location.state as { from?: string } | null)?.from;
  if (from) {
    return from;
  }
  return resolveCollectionBackPath(params);
}
